import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { AddSuppliers, getLocationList, emailExist_check, eventEdit, eventReject, commonAPI  } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX, BASEURL } from '../../constant.js';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';
const url = BASEURL;
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

class verticalEventsEdit extends Component {


    constructor(props) {
        super(props);
        this.state = {
            vendor_id: 1,
            pageid: '',
            categoryTypeList: [],
            subCategory: false,
            modeofpayment: '1',
            registration_no: '',
            org_name: '',
            sub_categories: '',
            contact_person: '',
            email_id: '',
            phone_number: '',
            website: '',
            facebook: '',
            twitter: '',
            event_fee: '',
            google_location: '',
            address: '',
            pincode: '',
            mod_payment: '',
            food: '',
            hall_capcity: '',
            dinning_capacity: '',
            car_parking_slot: '',
            two_parking_slot: '',
            about: '',
            timing: '',
            other_info: '',
            images: '',
            photos: '',
            location: 'Bengaluru',
            state: '',
            est_year: '',
            venueTypeList: [],
            mopList: [],
            category: this.props.match.params.ids,
            getId: this.props.match.params.seditid ? this.props.match.params.seditid : '',
            latitude: '',
            longitude: '',
            other_rating: '',
            tution_type: '',
            tutionList: [],
            typeListBool: false,
            attachment_file: [],
            attachment_file_length: 0,
            attachment_fileName: [],
            edit_image: '',
            delete_array: [],
            location_list: [],
            tempBanner: '',
            partner_type: '',
            preview: false,
            edited_data: [],
            keywordsArr: [],
            edited: false
        }
        this.validator = new SimpleReactValidator({
            validators: {
                checkExist: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (val == '' && this.state.edit_image == '') {
                            return false;
                        }
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                emailExist_check: {  // name the rule
                    message: 'The :attribute Already Exist.',
                    rule: (val, params, validator) => {
                        return this.state.isEmailValid;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                checkMobile: MOBILE_REGEX,
                checkUrl: URL_REGEX
            }
        });
        this.loadFile = this.loadFile.bind(this)
        this.Cat_type(); this.tutionList(); this.venue_type(); this.getpayment_type(); this.getKeywords();
    }
    async tutionList() {
        let response = await FetchCall.getSchoolListDatas('tution_type');
        console.log(response);
        if (response) {
            this.setState({ tutionList: response.results });
        }
    }
    async getpayment_type() {
        let response = await FetchCall.getSchoolListDatas('payment_type');
        console.log(response);
        if (response.status == 1) {
            this.setState({ mopList: response.results });
        }
    }
    async Cat_type() {
        let response = await FetchCall.getSubCategory('4');
        // console.log('categoryTypeList', response);
        if (response.status == 1) {
            this.setState({ categoryTypeList: response.results });
        }
    }
    async venue_type() {
        let response = await FetchCall.getSubCategory('110');
        // console.log('categoryTypeList', response);
        if (response.status == 1) {
            this.setState({ venueTypeList: response.results });
        }
    }
    validateMail = (value, catgry, vendr_id, pageid) => {
        let name = 'email_id';
        let type_name = 'isEmailValid';
        let req = JSON.stringify({
            [name]: value,
            category: catgry,
            vendor_id: vendr_id,
            pageid: pageid
        });
        let res = emailExist_check(req).then(res => {
            console.log('valuee', res);
            if (res.status === 1) {
                this.setState({
                    [type_name]: false
                });
            } else {
                // return res.status;
                this.setState({
                    [type_name]: true
                });
            }
        });
    }
    componentDidMount() {
        this.LocationDataList();
        if (this.state.getId) {
            this.getevent();
        }
        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({
            login_id: vendor_id,
            role: auth_data.role,
        });
    }

    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh');
    }

    getKeywords = () => {
        commonAPI(JSON.stringify({ url: 'get_site_keywords' })).then((res) => {
            if (res.status === 1) {
                this.setState({
                    keywordsArr: res.results
                })
            }
        })
    }
    LocationDataList = async () => {
        try {
            const res = await getLocationList();
            if (res.status == 1) {
                console.log('location_list', res.results)

                this.setState({
                    location_list: res.results,
                    error: false
                });
            }

        } catch (error) {
            this.setState({ error: true });
        }
    };
    async getevent() {
        let response = await eventEdit(JSON.stringify({ id: this.state.getId }));
        // console.log(response);
        if (response.status == 1) {
            const data = response.data, edited_data = response.original;
            this.setState({
                registration_no: data.registration_no,
                pageid: data.id,
                org_name: data.org_name,
                sub_categories: data.sub_categories.split(','),
                contact_person: data.contact_person,
                email_id: data.email_id,
                tution_type: data.tution_type,
                email_id: data.email_id,
                phone_number: data.phone_number,
                website: data.website,
                facebook: data.facebook,
                twitter: data.twitter,
                avg_fee: data.event_fee,
                google_location: data.google_location,
                address: data.address,
                pincode: data.pincode,
                modeofpayment: data.mod_payment,
                food: data.food != '' ? data.food : '',
                hall_capacity: data.hall_capcity != undefined ? data.hall_capcity : '',
                dinning_hall_capacity: data.dinning_capacity != undefined ? data.dinning_capacity : '',
                car_parking: data.car_parking_slot != undefined ? data.car_parking_slot : '',
                two_wheeler_parking: data.two_parking_slot != undefined ? data.two_parking_slot : '',
                about: data.about,
                timing: data.timing,
                other_info: data.other_info,
                images: data.images,
                category: data.category,
                location: data.location,
                state: data.state,
                est_year: data.est_year,
                attachment_file: data.photo_arr,
                edit_image: data.images ? data.url + data.images : '',
                edit_photos: data.photos,
                photos: data.photos,
                images: data.images,
                keywords: data.keywords ? data.keywords.split(';') : [],
                from_time: data.from_time,
                to_time: data.to_time,
                from_time_cate: data.from_time_cate,
                to_time_cate: data.to_time_cate,
                longitude: data.longitude,
                latitude: data.latitude,
                other_rating: data.other_rating,
                partner_type: data.partner_type,
                edited: data.edited,
                edited_data: edited_data
            });
            this.Geocode_location(data.google_location);
        }
    }
    UNSAFE_componentWillMount() {

    }
   

    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);

        this.setState({ [propName]: value });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name == 'google_location')
            this.Geocode_location();
        const propName = e.target.name;
        // if (propName == 'email_id') {
        //     this.validateMail(e.target.value, 7, this.state.vendor_id, this.state.pageid);
        // }
    };
    onSelect = (selectedList) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    onRemove = (selectedList, removedItem) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    handleFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let img = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            img = reader.result;
            THIS.setState({
                tempBanner: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBanner: ''
            });
        }
    };

    handleFileMultiple = (e) => {
        this.setState({ [e.target.name]: e.target.files });
    };


    Geocode_location(location = '') {
        Geocode.fromAddress(location ? location : this.state.google_location).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                if (lat && lng)
                    this.get_location(lat, lng);
            },
            error => {
                console.error(error);
            }
        );

    }


    get_location(lat, lng) {
        this.setState({
            latitude: lat,
            longitude: lng
        });
    }


    removeImage = e => {
        var delete_array = this.state.delete_array;
        delete_array.push(e)
        const updated = this.state.attachment_file.filter(item => item.name !== e)
        this.setState({
            attachment_file: updated,
            delete_array: delete_array,
        })
    }

    remove_img() {
        jQuery('#edit_image').remove();
    }

    loadFile(e) {
        var files = e.target.files
        this.setState({ attachment_file_length: files.length })
        if (files.length > 0) {
            jQuery('.upload-space').addClass('hide')
            jQuery('.upload-thumb').removeClass('hide')
            var fileArra = this.state.attachment_file

            //console.log('fileArra',fileArra)
            //var fileThumbArra = this.state.imgThumb;
            for (var i = 0; i < files.length; i++) {
                fileArra.push(e.target.files[i])
                this.setState({
                    selectedFile: URL.createObjectURL(e.target.files[i]),
                    attachment_file: fileArra
                })
            }
            this.clearValidationErr('attachment_file');
        }
    }

    handlePreview = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                preview: true
            })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        const { edited_data, edited } = this.state;
        this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Tuition Info Management</h4>
                                   
                   <div className="row">

                <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="">
                      <div id="company-info" className="tab-pane active">
                        
                       <form onSubmit={this.handlePreview} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Partner Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.partner_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="partner_type"
                                                                    title='Select'>
                                                                    <option value='1'>Institution</option>
                                                                    <option value='2'>Individuals</option>
                                                                </select>
                                                                {this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.registration_no != this.state.registration_no) && 'edited-field'}>
                                                                Registration No <span className="astrick">*</span></label>
                                                            <input type="text" name="registration_no" value={this.state.registration_no}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.org_name != this.state.org_name) && 'edited-field'}>
                                                                Name<span className="astrick">*</span></label>
                                                            <input type="text" name="org_name"
                                                                value={this.state.org_name}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Name', this.state.org_name, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.contact_person != this.state.contact_person) && 'edited-field'}>
                                                                Contact Person<span className="astrick">*</span></label>
                                                            <input type="text" name="contact_person" value={this.state.contact_person}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Contact Person', this.state.contact_person, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.email_id != this.state.email_id) && 'edited-field'}>
                                                                Email Id <span className="astrick">*</span></label>
                                                            <input type="text" name="email_id"
                                                                value={this.state.email_id}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.phone_number != this.state.phone_number) && 'edited-field'}>
                                                                Phone No <span className="astrick">*</span></label>
                                                            <input type="text" name="phone_number"
                                                                value={this.state.phone_number}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.state != this.state.state) && 'edited-field'}>
                                                                State<span className="astrick">*</span></label>
                                                            <input type="text" name="state"
                                                                value={this.state.state}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.location != this.state.location) && 'edited-field'}>
                                                                Location<span className="astrick">*</span></label>
                                                            <select
                                                                name="location"
                                                                id="location"
                                                                onChange={this.handleSelect}
                                                                value={this.state.location}
                                                                className="form-control selectpicker"
                                                                title='Select'
                                                            >
                                                                {this.state.location_list.length > 0 &&
                                                                    this.state.location_list.map((item, i) => {
                                                                        return (
                                                                            <option value={item.location} >
                                                                                {item.location}
                                                                            </option>
                                                                        )
                                                                    })}
                                                            </select>
                                                            {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.website != this.state.website) && 'edited-field'}>
                                                                Website<span className="astrick">*</span></label>
                                                            <input type="text" name="website"
                                                                value={this.state.website}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.facebook != this.state.facebook) && 'edited-field'}>
                                                                Facebook<span className="astrick">*</span></label>
                                                            <input type="text" name="facebook"
                                                                value={this.state.facebook}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.tution_type != this.state.tution_type) && 'edited-field'}>
                                                                Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.tution_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="tution_type" title='Select'>
                                                                    {this.state.tutionList.length > 0 &&
                                                                        this.state.tutionList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Type', this.state.tution_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.twitter != this.state.twitter) && 'edited-field'}>
                                                                Twitter<span className="astrick">*</span></label>
                                                            <input type="text" name="twitter"
                                                                value={this.state.twitter}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.avg_fee != this.state.avg_fee) && 'edited-field'}>
                                                                Avg Price <span className="astrick">*</span></label>
                                                            <input type="text" name="avg_fee" value={this.state.avg_fee}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Avg Price', this.state.avg_fee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.est_year != this.state.est_year) && 'edited-field'}>
                                                                Established Year <span className="astrick">*</span></label>
                                                            <input type="text" name="est_year" value={this.state.est_year}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.address != this.state.address) && 'edited-field'}>
                                                                Address<span className="astrick">*</span></label>
                                                            <input type="text" name="address"
                                                                value={this.state.address}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.google_location != this.state.google_location) && 'edited-field'}>
                                                                Google Location Address<span className="astrick">*</span></label>
                                                            <input type="text" name="google_location" value={this.state.google_location}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.latitude != this.state.latitude) && 'edited-field'}>
                                                                Latitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="latitude"
                                                                value={this.state.latitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.longitude != this.state.longitude) && 'edited-field'}>
                                                                Longitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="longitude"
                                                                value={this.state.longitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.other_rating != this.state.other_rating) && 'edited-field'}>
                                                                Google Rating
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step='0.01'
                                                                name="other_rating"
                                                                value={this.state.other_rating}
                                                                onChange={this.handleChange}
                                                                max='5'
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.pincode != this.state.pincode) && 'edited-field'}>
                                                                Pincode<span className="astrick">*</span></label>
                                                            <input type="text" name="pincode"
                                                                value={this.state.pincode}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.mod_payment != this.state.modeofpayment) && 'edited-field'}>
                                                                Mode of Payment<span className="astrick">*</span>
                                                            </label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.modeofpayment}
                                                                    name="modeofpayment"
                                                                    id="modeofpayment"
                                                                    onChange={this.handleSelect}
                                                                    className="form-control selectpicker"
                                                                    title='Select'
                                                                >
                                                                    {this.state.mopList.length > 0 &&
                                                                        this.state.mopList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.payment_name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Mode of Payment', this.state.modeofpayment, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>

                                                        {this.state.category == 110 ?
                                                            <span>
                                                                <div className="form-group col-md-4">
                                                                    <label
                                                                        className={edited && (edited_data.food != this.state.food) && 'edited-field'}>
                                                                        Food <span className="astrick">*</span></label>
                                                                    <input type="text" name="food"
                                                                        value={this.state.food}
                                                                        placeholder="Veg and Non Veg"
                                                                        onChange={this.handleChange} className="form-control" />
                                                                    {this.validator.message('Food', this.state.food, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label
                                                                        className={edited && (edited_data.hall_capacity != this.state.hall_capacity) && 'edited-field'}>
                                                                        Hall Capacity <span className="astrick">*</span></label>
                                                                    <input type="text" name="hall_capacity"
                                                                        value={this.state.hall_capacity}
                                                                        placeholder="40 - 2000"
                                                                        onChange={this.handleChange} className="form-control" />
                                                                    {this.validator.message('Hall Capacity', this.state.hall_capacity, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label
                                                                        className={edited && (edited_data.dinning_capacity != this.state.dinning_hall_capacity) && 'edited-field'}>
                                                                        Dinning Hall Capacity<span className="astrick">*</span></label>
                                                                    <input type="text" name="dinning_hall_capacity"
                                                                        value={this.state.dinning_hall_capacity}
                                                                        placeholder="500"
                                                                        onChange={this.handleChange} className="form-control" />
                                                                    {this.validator.message('Dinning Hall Capacity', this.state.dinning_hall_capacity, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label
                                                                        className={edited && (edited_data.car_parking_slot != this.state.car_parking) && 'edited-field'}>
                                                                        Car Parking<span className="astrick">*</span></label>
                                                                    <input type="text" name="car_parking"
                                                                        value={this.state.car_parking}
                                                                        placeholder="60"
                                                                        onChange={this.handleChange} className="form-control" />
                                                                    {this.validator.message('Dinning Hall Capacity', this.state.car_parking, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label
                                                                        className={edited && (edited_data.two_parking_slot != this.state.two_wheeler_parking) && 'edited-field'}>
                                                                        Two Wheeler Parking<span className="astrick">*</span></label>
                                                                    <input type="text" name="two_wheeler_parking"
                                                                        value={this.state.two_wheeler_parking}
                                                                        placeholder="190"
                                                                        onChange={this.handleChange} className="form-control" />
                                                                    {this.validator.message('Two Wheeler Parking', this.state.two_wheeler_parking, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </span>
                                                            : ''}

                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.timing != this.state.timing) && 'edited-field'}>
                                                                Operating hours<span className="astrick">*</span></label>
                                                            <input type="text" name="timing"
                                                                value={this.state.timing}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Operating hours', this.state.timing, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.about != this.state.about) && 'edited-field'}>
                                                                About<span className="astrick">*</span></label>
                                                            <textarea type="text" name="about"
                                                                value={this.state.about}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Other Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.keywords != this.state.keywords) && 'edited-field'}>
                                                                Keywords<span className="astrick">*</span></label>

                                                            <Multiselect
                                                                isObject={false}
                                                                options={this.state.keywordsArr} // Options to display in the dropdown
                                                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                                                onSelect={this.onSelect} // Function will trigger on select event
                                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                            />
                                                            {/* <textarea
                                                                name="keywords"
                                                                value={this.state.keywords}
                                                                onChange={this.handleChange}
                                                                className="form-control"
                                                                placeholder="ex: school,category names,location name,etc"
                                                            ></textarea> */}
                                                            {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.images != this.state.images) && 'edited-field'}>
                                                                Banner Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="images"
                                                                onChange={this.handleFile}
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })}
                                                            {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                        {(this.state.edit_image != '' || this.state.tempBanner != '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                                                    <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }

                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label
                                                                className={edited && (edited_data.photos != this.state.photos) && 'edited-field'}>
                                                                Gallery Images <span className="astrick">*</span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-12 float-left mt-4 p-0">

                                                            <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                                                <div className='upload-wizard'>
                                                                    <div className='upload-thumb'>
                                                                        <ul className='list-inline'>
                                                                            {this.state.attachment_file.map((file_data, index) => {

                                                                                var file_url;
                                                                                if (file_data.name) {
                                                                                    let url = file_data.image_thumb ? file_data.image_thumb : '';
                                                                                    if (url != '') {
                                                                                        file_url = file_data.image_thumb;
                                                                                    } else {
                                                                                        file_url = URL.createObjectURL(file_data);
                                                                                    }

                                                                                    // var file_url = URL.createObjectURL(file_data)
                                                                                    // var file_name = file_data.name
                                                                                    if (file_data.type === 'application/pdf') {
                                                                                        var blob = file_url
                                                                                        //console.log('blob_url', file_data.name)
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_name}</span> */}
                                                                                                <a
                                                                                                    href='javascript:;'
                                                                                                    className='del-btn'
                                                                                                    onClick={() => {
                                                                                                        this.removeImage(file_data.name)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                                                                <a
                                                                                                    href='javascript:;'
                                                                                                    className='del-btn'
                                                                                                    onClick={() => {
                                                                                                        this.removeImage(file_data.name)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            })}
                                                                            <li className='addMore'>
                                                                                <input
                                                                                    type='file'
                                                                                    name='imgInp[]'
                                                                                    id='imgInp2'
                                                                                    className='add_img'
                                                                                    multiple
                                                                                    onChange={this.loadFile.bind(this)}
                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                />
                                                                                <a href='javascript:;' className='add-more'>
                                                                                    <div>
                                                                                        <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                                                                        Add more
                                                                                    </div>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            {this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })}
                                                            {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-xs-12 btn-bdr">
                                                    <button className="btn btn-primary btn-sm">Preview</button>
                                                </div>
                                            </form>

                    </div>
                  </div>
                </div>
              </div>  


                </div>
              </div>
            </div>

             {this.preview()}

            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
preview = () => {
        return (
            <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
                <ModalBody className='p-0'>
                    <Row>
                        <Col md='12'>
                            <img src='/assets/images/user-header.png' className='preview-header' />
                        </Col>
                    </Row>
                    <Row className='pv-banner'>
                        <Col className='pv-banner-bg' md='12'>
                            <div className='title-section'>
                                <p className="banner-title">{this.state.org_name}</p>
                                <p className="banner-address">{this.state.address}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>About</h4>
                                <p className="">{this.state.about}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Key Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Contact Person</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.contact_person}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Email Id</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.email_id}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Avg Fee</b></div>
                                        <div className='key-po'>
                                            <p>{parseFloat(this.state.avg_fee) > 0 ? `${this.state.avg_fee}` : 'NA'}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Year Established</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.est_year}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Mode of Payment</b></div>
                                        <div className='key-po'>
                                            <p> {this.state.mopList.map((item) => {
                                                if (item.id == this.state.modeofpayment) {
                                                    return (
                                                        item.payment_name
                                                    )
                                                }
                                            })}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Operating hours</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.timing}</p>
                                        </div>
                                    </div>
                                    {this.state.category == 110 && (
                                        <React.Fragment>
                                            <div className='col-md-4'>
                                                <div className='type-n7ngd'><b>Food </b></div>
                                                <div className='key-po'>
                                                    <p>{this.state.food}</p>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='type-n7ngd'><b>Hall Capacity</b></div>
                                                <div className='key-po'>
                                                    <p>{this.state.hall_capacity}</p>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='type-n7ngd'><b>Dinning Hall Capacity</b></div>
                                                <div className='key-po'>
                                                    <p>{this.state.dinning_hall_capacity}</p>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='type-n7ngd'><b>Car Parking</b></div>
                                                <div className='key-po'>
                                                    <p>{this.state.car_parking}</p>
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='type-n7ngd'><b>Two Wheeler Parking</b></div>
                                                <div className='key-po'>
                                                    <p>{this.state.two_wheeler_parking}</p>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}

                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Facebook</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.facebook}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Twitter</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.twitter}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Phone No</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.phone_number}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Gallery</h4>
                                <div className='row'>
                                    {this.state.attachment_file.map((item) => {
                                        console.log('********', item);
                                        if (item.image_thumb) {
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={item.image_thumb} className='preview-image' />
                                                </div>
                                            )
                                        } else if (item.name) {
                                            let file_url = URL.createObjectURL(item);
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={file_url} className='preview-image' />
                                                </div>
                                            )
                                        }
                                    })}
                                    {this.state.attachment_file.length === 0 && (
                                        <div className='col-md-4'>No Gallery Images Found</div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Contact Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        Email Id : {this.state.email_id}
                                    </div>
                                    <div className='col-md-4'>
                                        Contact : {this.state.phone_number}
                                    </div>
                                    <div className='col-md-4'>
                                        Website : {this.state.website}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                                {this.state.edited && this.state.role == 1 ? 'Approve' : 'Submit'}
                            </button>
                            {this.state.edited && this.state.role == 1 && (
                                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                                    onClick={this.handleReject}>
                                    Reject
                                </button>
                            )}
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ preview: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >
        )
    }
    handleReject = (e) => {
        e.preventDefault();
        let req = JSON.stringify({
            id: this.state.getId
        })
        let toastr = '';
        eventReject(req).then((res => {
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
                window.location.href = document.referrer;
            }
        }))
    }
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            let indData = {
                getId: this.state.getId,
                registration_no: this.state.registration_no,
                org_name: this.state.org_name,
                sub_categories: this.state.sub_categories,
                contact_person: this.state.contact_person,
                email_id: this.state.email_id,
                phone_number: this.state.phone_number,
                website: this.state.website,
                facebook: this.state.facebook,
                tution_type: this.state.tution_type,
                twitter: this.state.twitter,
                event_fee: this.state.avg_fee,
                google_location: this.state.google_location,
                address: this.state.address,
                pincode: this.state.pincode,
                mod_payment: this.state.modeofpayment,
                food: this.state.food,
                hall_capcity: this.state.hall_capacity,
                dinning_capacity: this.state.dinning_hall_capacity,
                car_parking_slot: this.state.car_parking,
                two_parking_slot: this.state.two_wheeler_parking,
                about: this.state.about,
                timing: this.state.timing,
                other_info: this.state.other_info,
                images: this.state.images,
                photos: this.state.attachment_file,
                login_id: this.state.login_id,
                category: this.state.category,
                location: this.state.location,
                state: this.state.state,
                est_year: this.state.est_year,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                other_rating: this.state.other_rating,
                keywords: this.state.keywords ? this.state.keywords.join(';') : '',
                delete_array: this.state.delete_array,
                partner_type: this.state.partner_type,
                role: this.state.role,
            }
            // jQuery("#btnSubmit").attr('disabled', true);
            AddSuppliers(indData).then((res) => {
                let toastr = '';
                if (res.status === 1) {
                    alert("Created successfully");

                    window.location.href = document.referrer;

                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    alert("Error");
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };
}


export default verticalEventsEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalEventsEdit.jsx